import { Text } from '@mantine/core';

interface IInputLabel {
  label: string;
  required?: boolean;
}

const InputLabel = ({ label, required}: IInputLabel) => (
  <Text size={'sm'} mb={4}>
    {label}
    {required && <span style={{color: 'var(--mantine-color-error)'}}> *</span>}
  </Text>
  )

export default InputLabel;